export class SystemCountry {
	id: string;
	name: string;

	constructor() {
	}
}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/models/system-country.ts